import React from "react";
import { Card, List, Avatar, Badge, Typography } from "antd";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import AddEditAnnouncement from "pages/Announcement/AddEditAnnouncement";

const { Text, Title } = Typography;

const Wrapper = styled(Card)`
  border-radius: 12px;
  border: none;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
  }

  .view-all {
    color: #1d4ed8;
    cursor: pointer;
    font-weight: 500;
  }
`;

const ListWrapper = styled.div`
  max-height: 300px;
  overflow-y: auto;
  padding-right: 4px;

  /* scrollbar */
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: #e5e7eb;
    border-radius: 4px;
  }
`;

const AnnouncementItem = styled(List.Item)`
  padding: 12px;
  border-radius: 10px;
  cursor: pointer;

  &:hover {
    background: #f9fafb;
  }

  &.active {
    background: #f3f4f6;
  }

  .time {
    color: #6b7280;
    font-size: 13px;
  }
`;

const announcements = [
  {
    id: 1,
    title: "General announcement regarding shift change",
    time: "04th Mar, 2024 · 10:20 AM",
    avatar: "https://randomuser.me/api/portraits/women/44.jpg",
    unread: true,
  },
  {
    id: 2,
    title: "General announcement regarding shift change",
    time: "04th Mar, 2024 · 10:20 AM",
    avatar: "https://randomuser.me/api/portraits/men/32.jpg",
    unread: false,
  },
  {
    id: 3,
    title: "General announcement regarding shift change",
    time: "04th Mar, 2024 · 10:20 AM",
    avatar: "https://randomuser.me/api/portraits/women/68.jpg",
    unread: false,
  },
  {
    id: 4,
    title: "General announcement regarding shift change",
    time: "04th Mar, 2024 · 10:20 AM",
    avatar: "https://randomuser.me/api/portraits/men/76.jpg",
    unread: false,
  },
  {
    id: 5,
    title: "General announcement regarding shift change",
    time: "04th Mar, 2024 · 10:20 AM",
    avatar: "https://randomuser.me/api/portraits/women/12.jpg",
    unread: false,
    active: true,
  },
];

const AnnouncementList = () => {
  const history = useHistory();
  const unreadCount = announcements.filter((a) => a.unread).length;

  return (
    <Wrapper>
      {/* Header */}
      <div className="header">
        <Title level={5}>
          Announcement{" "}
          <Badge count={unreadCount} style={{ backgroundColor: "#ef4444" }} />
        </Title>
        <Text className="view-all" style={{ cursor: "pointer" }} 
        // onClick={() => history.push("/announcement")}
        >View All</Text>
      </div>

      {/* List */}
      <ListWrapper>
        <List
          itemLayout="horizontal"
          dataSource={announcements}
          renderItem={(item) => (
            <AnnouncementItem className={item.active ? "active" : ""}>
              <List.Item.Meta
                avatar={
                  <Badge dot={item.unread} offset={[-2, 4]}>
                    <Avatar src={item.avatar} />
                  </Badge>
                }
                title={<Text>{item.title}</Text>}
                description={<span className="time">{item.time}</span>}
              />
            </AnnouncementItem>
          )}
        />
      </ListWrapper>
    </Wrapper>
  );
};

export default AnnouncementList;
